import { ExamResult } from '@/interfaces/examResult';
import { ExamResultFilters } from '@/interfaces/filters/examResultFilters';
import { UserExamResultFilters } from '@/interfaces/filters/userExamResultFilters';
import { EntityResource } from './entity.resource';

/**
 * Resource wyników egzaminu
 *
 * @export
 * @class ExamResultResource
 * @extends {EntityResource<ExamResult>}
 */
export class ExamResultResource extends EntityResource<ExamResult> {
  protected getFields = {
    id: true,
    date: true,
    score: true,
    profileId: true,
    examId: true
  };

  protected listFields = {
    id: true,
    profile: {
      id: true,
      firstName: true,
      lastName: true
    },
    exam: {
      id: true,
      name: true,
      unit: true
    },
    team: {
      id: true,
      name: true
    },
    date: true,
    score: true
  };

  protected listVariables = { filters: 'ExamResultFilters' };

  constructor() {
    super({ entityName: 'examResult' });
  }

  /**
   * Lista wyników egzaminów użytkownika
   *
   * @param {UserExamResultFilters} filters
   * @returns
   * @memberof ExamResultResource
   */
  public userExamResultList(filters: UserExamResultFilters) {
    this.listQueryName = 'userExamResultList';
    return super.list(filters);
  }

  /**
   * Lista wyników egzaminu
   *
   * @param {ExamResultFilters} filters
   * @returns
   * @memberof ExamResultResource
   */
  public examResultList(filters: ExamResultFilters) {
    this.listQueryName = 'examResultList';
    return super.list(filters);
  }
}

export const examResultResource = new ExamResultResource();
